angular.module('harriApp')
    .service('BrandProfileDataBus', [
        function () {
            var self = this;
            var data;
            self.setData = function (_data) {
                if (_data?.background_image?.media_secondary) {
                    _data.background_image.media_secondary.sort((a, b) => a.order - b.order);
                }
                data = _data;
            };

            self.getData = function () {
                return data;
            };

            self.cleanData = function () {
                data = null;
            };
        }]);
